export default __webpack_public_path__ + "static/media/firewall-inbound.bf4b50c2.svg";